import React from 'react';
import toast from 'react-hot-toast';
import { IoIosArrowForward } from 'react-icons/io';
import { FaFileUpload } from 'react-icons/fa';
import useDrivePicker from 'react-google-drive-picker';

import {
  uploadFiles,
  uploadFilesFromDrive,
  uploadImages,
} from '../services/api';
import { google_client_id, google_api_key } from '../utils/keys';

const FileManagement = ({
  userGoogleId,
  setJustSavedFiles,
  setTempImages,
  setJustUploadedImages,
  task_id,
}) => {
  const handleFileChange = async (event) => {
    const selected = Array.from(event.target.files);

    if (selected.length === 0) return;
    if (selected.length > 10) {
      toast.error('You can select a maximum of 10 files at a time.');
      return;
    }

    const imagesToUpload = selected.filter((file) =>
      file.type.startsWith('image/'),
    );
    const otherFilesToUpload = selected.filter(
      (file) => !file.type.startsWith('image/'),
    );

    // FIX: Create temporary image placeholders for instant UI feedback
    if (imagesToUpload.length > 0) {
      const newTempImages = imagesToUpload.map((file) => ({
        id: Date.now() + Math.random(),
        url: URL.createObjectURL(file),
        uploading: true,
      }));
      setTempImages(newTempImages);
    }

    try {
      if (imagesToUpload.length > 0) {
        const imageData = await uploadImages(
          userGoogleId,
          task_id,
          imagesToUpload,
        );
        if (imageData.error) {
          toast.error('Failed to upload some images.');
        } else {
          setJustUploadedImages(true); // Signal ImageComponent to refresh
        }
      }

      if (otherFilesToUpload.length > 0) {
        const fileData = await uploadFiles(
          userGoogleId,
          task_id,
          otherFilesToUpload,
        );
        if (fileData && !fileData.error) {
          setJustSavedFiles(true);
        } else {
          toast.error('Failed to upload some files.');
        }
      }

      if (selected.length > 0) {
        toast.success('Files uploaded successfully!');
      }
    } catch (error) {
      toast.error('An error occurred during upload.');
    } finally {
      setTempImages([]); // Clear temporary images after completion
    }
  };

  const [openPicker] = useDrivePicker();
  const handleOpenPicker = () => {
    openPicker({
      clientId: google_client_id,
      developerKey: google_api_key,
      viewId: 'DOCS',
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      // customViews: customViewsArray, // custom view
      callbackFunction: async (data) => {
        if (data.action === 'cancel') {
        }
        if (data.action === 'picked') {
          // Extract file IDs from the picker response
          const fileIds = data.docs.map((doc) => doc.id);
          try {
            const responseData = await uploadFilesFromDrive(
              userGoogleId,
              task_id,
              fileIds,
            );
            if (responseData.error) {
            } else {
              setJustSavedFiles(true);
            }
          } catch (e) {
            toast.error('File upload failed');
          }
        }
      },
    });
  };

  return (
    <div className="bg-2 rounded-2xl px-3 py-2 text-white shadow-md shadow-zinc-700">
      <button
        onClick={() => handleOpenPicker()}
        className="flex items-center justify-between gap-2 rounded-xl p-2 transition-all duration-300 hover:bg-zinc-700 hover:bg-opacity-30"
      >
        <div className="flex items-center gap-2">
          <img
            alt="-"
            src="https://res.cloudinary.com/dsguoq6ad/image/upload/v1726229007/mentorEducationImages/lhupskidmwtibynwa0no.png"
            className="h-5 w-5"
          />
          <span className="text-xs">Connect to Google Drive</span>
        </div>
        <IoIosArrowForward />
      </button>
      <div className="relative mb-1 mt-1 h-[1px] w-full overflow-hidden bg-zinc-700"></div>
      <div className="flex cursor-pointer items-center justify-between gap-2 rounded-xl p-2 transition-all duration-300 hover:bg-zinc-700 hover:bg-opacity-30">
        <div className="flex cursor-pointer items-center gap-2">
          <FaFileUpload className="h-5 w-5 cursor-pointer text-white" />
          <span className="cursor-pointer text-xs">Upload from computer</span>
        </div>
        <IoIosArrowForward />
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="absolute w-60 cursor-pointer bg-zinc-400 opacity-0"
        />
      </div>
    </div>
  );
};

export default FileManagement;
